import React, { useState } from 'react';
import { faqCategories } from '../data/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import CTA from '../components/CTA';

export default function FAQ() {
  const [active, setActive] = useState(faqCategories[0].category);
  const current = faqCategories.find((c) => c.category === active);

  return (
    <main>
      <section className="pt-12 pb-8 md:py-20">
        <div className="max-w-5xl mx-auto px-5 md:px-6 text-center">
          <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">
            Frequently Asked Questions
          </div>
          <h1 className="font-display font-bold text-3xl sm:text-4xl md:text-6xl text-splash-green leading-tight">
            Everything you need to know.
          </h1>
          <p className="mt-4 text-splash-green/80 max-w-2xl mx-auto text-sm md:text-base">
            Answers to the most common questions about lessons, safety, scheduling, and progress at Little Splash.
          </p>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          {/* Mobile category select (< md) */}
          <div className="md:hidden mb-5">
            <label className="block text-xs uppercase tracking-widest text-splash-green/70 mb-2 font-semibold">
              Choose a topic
            </label>
            <Select value={active} onValueChange={setActive}>
              <SelectTrigger className="w-full h-12 rounded-xl border-splash-sand bg-white text-splash-green font-medium">
                <SelectValue placeholder="Select a topic" />
              </SelectTrigger>
              <SelectContent>
                {faqCategories.map((c) => (
                  <SelectItem key={c.category} value={c.category}>
                    {c.category}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="grid lg:grid-cols-4 gap-6 lg:gap-8">
            {/* Tablet & desktop sidebar (>= md) */}
            <aside className="hidden md:block lg:col-span-1">
              <div className="lg:sticky lg:top-24 flex flex-wrap lg:flex-col gap-2">
                {faqCategories.map((c) => (
                  <button
                    key={c.category}
                    onClick={() => setActive(c.category)}
                    className={`text-left px-4 py-3 rounded-xl font-medium btn-transition whitespace-nowrap text-sm ${
                      active === c.category
                        ? 'bg-splash-teal text-white'
                        : 'bg-white border border-splash-sand text-splash-green hover:bg-splash-cream'
                    }`}
                  >
                    {c.category}
                  </button>
                ))}
              </div>
            </aside>

            <div className="lg:col-span-3">
              <div className="bg-white rounded-2xl md:rounded-3xl border border-splash-sand p-4 md:p-8">
                <div className="md:hidden mb-3 pb-3 border-b border-splash-sand">
                  <div className="text-xs uppercase tracking-widest text-splash-coral font-semibold">
                    {active}
                  </div>
                </div>
                <Accordion
                  type="single"
                  collapsible
                  defaultValue="item-0"
                  key={active}
                  className="w-full"
                >
                  {current.items.map((item, idx) => (
                    <AccordionItem key={item.q} value={`item-${idx}`} className="border-splash-sand">
                      <AccordionTrigger className="text-left font-display font-semibold text-splash-green hover:no-underline hover:text-splash-teal text-base md:text-xl gap-3 py-4">
                        <span className="pr-2">{item.q}</span>
                      </AccordionTrigger>
                      <AccordionContent className="text-splash-green/80 leading-relaxed text-sm md:text-base">
                        {item.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CTA />
    </main>
  );
}
